module.exports = __webpack_public_path__ + "img/588x310-03.4db5f05b.png";